import React from 'react';
import { Lock } from 'lucide-react';

export const SectionHeader = ({ eyebrow, title, children }) => (
  <header className="mb-8 jr-rise">
    {eyebrow && <p className="text-[11px] uppercase tracking-[0.2em] text-teal-700 font-semibold mb-3">{eyebrow}</p>}
    <h1 className="font-outfit text-3xl sm:text-4xl font-bold text-[#0b1f4d] tracking-tight">{title}</h1>
    {children && <p className="mt-3 text-slate-600 max-w-2xl text-sm sm:text-base leading-relaxed">{children}</p>}
  </header>
);

export const Card = ({ className = '', children, ...rest }) => (
  <div className={`${/(^|\s)bg-/.test(className) ? '' : 'bg-white '}rounded-2xl border border-slate-200/80 p-6 jr-rise ${className}`} {...rest}>{children}</div>
);

export const Pill = ({ className = '', children, ...rest }) => (
  <span className={`inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-full ${className}`} {...rest}>{children}</span>
);

export const ScoreBar = ({ label, value, testid }) => {
  const tone = value >= 70 ? 'bg-teal-500' : value >= 50 ? 'bg-amber-400' : 'bg-rose-400';
  return (
    <div data-testid={testid}>
      <div className="flex justify-between text-sm mb-1.5"><span className="text-slate-600">{label}</span><span className="font-semibold text-[#0b1f4d]">{value}/100</span></div>
      <div className="h-2 rounded-full bg-slate-100 overflow-hidden"><div className={`h-full ${tone} rounded-full transition-[width] duration-700`} style={{ width: `${value}%` }} /></div>
    </div>
  );
};

export const LockedNotice = ({ title, text, action, onAction, testid }) => (
  <Card className="text-center py-12" data-testid={testid}>
    <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mx-auto mb-4"><Lock className="w-5 h-5 text-slate-500" /></div>
    <p className="font-outfit font-semibold text-lg text-[#0b1f4d]">{title}</p>
    <p className="text-sm text-slate-600 mt-2 max-w-md mx-auto">{text}</p>
    {action && <button onClick={onAction} className="mt-5 text-sm font-semibold text-teal-700 hover:text-teal-800" data-testid={`${testid}-action`}>{action} →</button>}
  </Card>
);

export const PrimaryButton = ({ className = '', children, ...rest }) => (
  <button className={`inline-flex items-center justify-center gap-2 bg-[#0b1f4d] text-white font-semibold px-5 py-3 rounded-full hover:bg-[#13306f] disabled:opacity-50 transition-colors ${className}`} {...rest}>{children}</button>
);
